import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=3bf0cac4&scoped=true"
import script from "./Inventario.vue?vue&type=script&lang=js"
export * from "./Inventario.vue?vue&type=script&lang=js"
import style0 from "./Inventario.vue?vue&type=style&index=0&id=3bf0cac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0cac4",
  null
  
)

export default component.exports